import { format, setMinutes } from 'date-fns';
import { GANTT_DATE_FORMAT } from '../../hooks';

const dateTimeAttribute = 'data-time-value';

export const setMinutesToZero = (date: Date) => setMinutes(date, 0);
export const formatDate = (date: Date | string) => format(setMinutesToZero(new Date(date)), GANTT_DATE_FORMAT);
export const dateToSelector = (date: Date) => `[${dateTimeAttribute}="${formatDate(date)}"]` as const;
export const getDateTimeAttribute = (date: Date) => {
  return { [dateTimeAttribute]: formatDate(date) };
};

export const ganttFormatters = {
  setMinutesToZero,
  formatDate,
  dateToSelector,
  dateTimeAttribute,
  getDateTimeAttribute,
};
